import React from 'react';

const OnTrackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#00B2A9"
      d="M14.776 5.93l-4.188 4.65-1.954-1.758c-.407-.366-1.032-.338-1.403.063l-5.625 6.077c-.376.405-.35 1.038.054 1.413.404.375 1.037.35 1.412-.054l4.956-5.352 1.965 1.77c.41.368 1.043.335 1.412-.075l5.206-5.78V9.69c0 .553.448 1 1 1 .553 0 1-.447 1-1V4.93c0-.552-.447-1-1-1H12.66c-.552 0-1 .448-1 1s.448 1 1 1h2.118z"
    />
  </svg>
);

export default OnTrackIcon;
